import api from 'common/api'
import { APP } from 'common/metadata-constants'
import getSessionId from 'common/track-events-session-id'

const trackEvent = (config: any, app: string = APP) => {
  const payload = {
    EventSourceApplication: app,
    ...config,
    EventTimestamp: new Date(),
  }
  payload.SessionId = getSessionId(payload.EventSourceApplication)
  return api.post('/api/track/event', payload)
}

export default trackEvent
